import React from "react";

/**
 * Restrict how much of the UI is affected by errors.
 *
 * Errors will still be sent to the console and the UI within the ErrorBoundary
 * won't render.
 *
 * See https://reactjs.org/docs/error-boundaries.html.
 *
 * Usage:
 *
 *     <ErrorBoundary>
 *        <MyComponent />
 *        ...
 *     </ErrorBoundary>
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[election-center-widgets] Error rendering component",
      error, errorInfo);
  }

  render() {
    const message = this.props.message
      ? <div className="ec-widgets-error">{this.props.message}</div>
      : <></>;

    // Don't render anything if there was an error.
    return this.state.hasError
      ? message
      : this.props.children;
  }
}

export default ErrorBoundary;
